/* eslint-disable react/jsx-key */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Fragment } from 'react';
import UserContext from '../context/context';
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useState,
} from '@wordpress/element';
import { addQueryArgs } from '@wordpress/url';
import AnimateHeight from 'react-animate-height';
import { Accordion, Button } from 'semantic-ui-react';
import smoothscroll from 'smoothscroll-polyfill';

const FEATURE_POST_SLUG = 'political-typology-comparison-2026';

/**
 * Resolve the selected issue slug from the current URL or server-injected prcURLVars.
 *
 * Prefers explicit query (?prcFeatureUrlParamA=), then pathname segment after the feature slug
 * (pretty permalinks), then initial prcFeatureUrlVars from the loader inline script.
 *
 * @return {string|null} Resolved child slug when the URL specifies an issue; otherwise null.
 */
function getIssueSlugFromLocation() {
	const fromQuery = new URLSearchParams(window.location.search).get(
		'prcFeatureUrlParamA'
	);
	if (fromQuery) {
		return fromQuery.trim();
	}

	const parts = window.location.pathname
		.replace(/\/$/, '')
		.split('/')
		.filter(Boolean);
	const idx = parts.lastIndexOf(FEATURE_POST_SLUG);
	if (idx !== -1 && parts[idx + 1]) {
		return parts[idx + 1].trim();
	}

	if (
		typeof window.prcURLVars !== 'undefined' &&
		window.prcURLVars.prcFeatureUrlParamA
	) {
		return String(window.prcURLVars.prcFeatureUrlParamA).trim();
	}

	return null;
}

const Menu = ({ myTable }) => {
	const context = useContext(UserContext);
	const MOBILE_BREAKPOINT = 500;
	console.log('hello from menu again!');

	const {
		issues,
		selectedChild,
		selectedView,
		updateParent,
		updateChild,
		updateView,
		selectChildBySlug,
	} = context;

	const [activeIndex, setActiveIndex] = useState(0);

	const filteredIssues = useMemo(() => {
		if (selectedView === 'demographics') {
			return issues.filter(
				(issue) => issue.parent_slug === 'demographics'
			);
		}
		return issues.filter((issue) => issue.parent_slug !== 'demographics');
	}, [issues, selectedView]);

	const handleClick = (e, titleProps) => {
		const { index } = titleProps;
		const newIndex = activeIndex === index ? -1 : index;

		setActiveIndex(newIndex);
	};

	const updateURL = (slug) => {
		const url = addQueryArgs(window.location.href, {
			prcFeatureUrlParamA: slug,
		});
		window.history.pushState({ ...window.history.state, slug }, '', url);
	};

	const updateChildItem = useCallback(
		(child) => {
			if (window.innerWidth <= MOBILE_BREAKPOINT) {
				myTable.current.scrollIntoView({ behavior: 'smooth' });
				smoothscroll.polyfill();
			}

			updateChild(child);
			updateURL(child.slug);
		},
		[MOBILE_BREAKPOINT, myTable, updateChild]
	);

	useEffect(() => {
		const currentIssue = issues.find((issue) =>
			issue.children.some((c) => c.slug === selectedChild.slug)
		);
		const stillVisible =
			currentIssue && filteredIssues.includes(currentIssue);
		if (stillVisible) {
			setActiveIndex(filteredIssues.indexOf(currentIssue));
			return;
		}
		const first = filteredIssues[0];
		if (first?.children[0]) {
			setActiveIndex(0);
			updateChildItem(first.children[0]);
		}
	}, [filteredIssues, issues, selectedChild, updateChildItem]);

	const applySlugToMenu = useCallback(
		(slug) => {
			const match = selectChildBySlug(slug);
			if (!match) {
				return;
			}
			const filtered =
				match.issue.parent_slug === 'demographics'
					? issues.filter(
							(issue) => issue.parent_slug === 'demographics'
					  )
					: issues.filter(
							(issue) => issue.parent_slug !== 'demographics'
					  );
			const idx = filtered.indexOf(match.issue);
			setActiveIndex(idx >= 0 ? idx : 0);
		},
		[issues, selectChildBySlug]
	);

	// initial load of the page
	useEffect(() => {
		const slug = getIssueSlugFromLocation();
		if (!slug) {
			return;
		}
		applySlugToMenu(slug);
	}, [applySlugToMenu]);

	// when the user clicks back or forward in the browser
	useEffect(() => {
		const onPopState = () => {
			const slug = getIssueSlugFromLocation();
			if (!slug) {
				return;
			}
			applySlugToMenu(slug);
		};

		window.addEventListener('popstate', onPopState);
		return () => window.removeEventListener('popstate', onPopState);
	}, [applySlugToMenu]);

	return (
		<Fragment>
			<h4 className="accordion-menu-title"> BROWSE BY: </h4>
			<Button.Group basic>
				<Button
					basic
					active={selectedView === 'key topics'}
					onClick={() => updateView('key topics')}
				>
					KEY TOPICS
				</Button>
				<Button
					basic
					active={selectedView === 'demographics'}
					onClick={() => updateView('demographics')}
				>
					DEMOGRAPHICS
				</Button>
			</Button.Group>

			<Accordion className="vertical menu text">
				{filteredIssues.map((issue, i) => {
					return (
						<Fragment>
							<div className="item">
								<Accordion.Title
									active={activeIndex === i}
									index={i}
									onClick={handleClick}
									className="header"
									aria-controls="accordion-animate"
								>
									{activeIndex === i ? (
										<svg
											width="19"
											height="15"
											viewBox="0 0 19 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM3.97058 7C3.69444 7 3.47058 7.22386 3.47058 7.5C3.47058 7.77614 3.69444 8 3.97058 8H11.0294C11.3055 8 11.5294 7.77614 11.5294 7.5C11.5294 7.22386 11.3055 7 11.0294 7H3.97058Z"
												fill="#818181"
											/>
										</svg>
									) : (
										<svg
											width="19"
											height="15"
											viewBox="0 0 15 15"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M14 7.5C14 11.0899 11.0899 14 7.5 14C3.91015 14 1 11.0899 1 7.5C1 3.91015 3.91015 1 7.5 1C11.0899 1 14 3.91015 14 7.5ZM15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5ZM7.53402 3.52941C7.81017 3.52941 8.03402 3.75327 8.03402 4.02941V7H11.0294C11.3056 7 11.5294 7.22386 11.5294 7.5C11.5294 7.77614 11.3056 8 11.0294 8H8.03402V10.9706C8.03402 11.2467 7.81017 11.4706 7.53402 11.4706C7.25788 11.4706 7.03402 11.2467 7.03402 10.9706V8H3.97059C3.69445 8 3.47059 7.77614 3.47059 7.5C3.47059 7.22386 3.69445 7 3.97059 7H7.03402V4.02941C7.03402 3.75327 7.25788 3.52941 7.53402 3.52941Z"
												fill="#818181"
											/>
										</svg>
									)}
									{issue.parent}
								</Accordion.Title>
								<AnimateHeight
									duration={500}
									height={activeIndex === i ? 'auto' : 0}
									id="accordion-animate"
								>
									<Accordion.Content
										active={activeIndex === i}
										className="menu"
									>
										{issue.children.map((child) => (
											<a
												className={`item   ${
													selectedChild.name ===
													child.name
														? 'active'
														: ''
												}`}
												data-slug={child.slug}
												onClick={() =>
													updateChildItem(child)
												}
											>
												{child.name}
											</a>
										))}
									</Accordion.Content>
								</AnimateHeight>
							</div>
							<hr />
						</Fragment>
					);
				})}
			</Accordion>
		</Fragment>
	);
};

export default Menu;
